<template>
    <v-dialog :value="true" persistent max-width="600">
        <v-card>
            <!-- HEADER -->
            <v-card-title class="headline justify-center">
                <v-spacer />
                {{ title }}
                <v-spacer />
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <!-- STEP 1: DIGITAR TOKEN -->
            <v-card-text
                v-if="step === 'TOKEN'"
                class="text-center"
            >
                <v-alert outlined color="success" class="mb-4">
                    {{ $t('conta.digiteCodigoWhatsapp') }}
                </v-alert>

                <v-form ref="form">
                    <v-otp-input
                        length="6"
                        type="tel"
                        v-model="token"
                        :rules="[rules.empty]"
                        dense
                        class="mb-4"
                        @finish="onTokenFilled"
                    />

                    <v-btn
                        text
                        small
                        color="primary"
                        :disabled="resendBtnDisabled"
                        @click="createAccount"
                    >
                        {{ $t('conta.reenviarCodigo') }}
                    </v-btn>
                </v-form>
            </v-card-text>

            <!-- STEP 2: FORMULÁRIO -->
            <v-card-text v-else>
                <v-form ref="form">
                    <v-text-field
                        :label="$t('envio.nomeCompleto')"
                        ref="nome"
                        v-model="nome"
                        :rules="[rules.empty]"
                        outlined
                        dense
                    />

                    <v-text-field
                        :label="$t('conta.crieSenha')"
                        ref="password"
                        v-model="password"
                        :type="showPassword ? 'text' : 'password'"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword = !showPassword"
                        :rules="[rules.password]"
                        :hint="senhaRegra()"
                        persistent-hint
                        outlined
                        dense
                        class="mb-4"
                    />

                    <v-text-field
                        :label="$t('conta.confirmeSenha')"
                        ref="passwordConfirm"
                        v-model="passwordConfirm"
                        :type="showPasswordConfirm ? 'text' : 'password'"
                        :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPasswordConfirm = !showPasswordConfirm"
                        :rules="[rules.empty]"
                        outlined
                        dense
                    />
                </v-form>
            </v-card-text>

            <!-- ACTION -->
            <v-card-actions v-if="step === 'FORM'">
                <v-btn
                    block
                    large
                    color="primary"
                    class="white--text"
                    :loading="loading"
                    @click="validateAccount"
                >
                    {{ $t('envio.confirmar') }}
                    <v-icon class="ml-1">mdi-arrow-right</v-icon>
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import i18n from '@/i18n';
import { getPasswordError, senhaRegra } from '@/utils/validate';

export default {
    name: 'CreateAccount',

    props: ['value', 'ddi'],

    data: () => ({
        step: 'TOKEN', // TOKEN | FORM

        resendBtnDisabled: true,
        loading: false,

        showPassword: false,
        showPasswordConfirm: false,

        token: '',
        nome: '',
        password: '',
        passwordConfirm: '',

        rules: {
            empty: v => !!v || i18n.t('conta.obrigatorio'),
            password: v => getPasswordError(v) || true,
        },
    }),

    computed: {
        title() {
            return this.step === 'FORM' ? this.$t('conta.crieSenha') : this.$t('conta.digiteCodigo');
        },
    },

    mounted() {
        this.createAccount();
    },

    methods: {
        senhaRegra() {
            return senhaRegra();
        },

        onTokenFilled() {
            if (this.token.length === 6) {
                this.step = 'FORM';
                this.$nextTick(() => this.$refs.nome?.focus());
            }
        },

        createAccount() {
            if (!this.value) {
                this.notify(this.$t('conta.whatsappInvalido'), 'warning');
                return;
            }

            this.resendBtnDisabled = true;

            const data = { whatsapp: this.value, whatsapp_ddi: this.ddi };

            this.$http.post('create-account', data)
                .then(resp => {
                    if (resp.data.type === 'warning') {
                        this.notify(resp.data.msg, 'warning');
                        return;
                    }

                    this.notify(resp.data.msg);
                })
                .catch(() => {
                    this.notify(this.$t('conta.naoEnviouCodigo'), 'warning');
                })
                .finally(() => {
                    setTimeout(() => (this.resendBtnDisabled = false), 60000);
                });
        },

        validateAccount() {
            const erroSenha = getPasswordError(this.password);
            if (erroSenha) {
                this.notify(erroSenha, 'warning');
                return;
            }

            if (this.password !== this.passwordConfirm) {
                this.notify(this.$t('conta.senhaNaoConfere'), 'warning');
                return;
            }

            if (!this.$refs.form.validate()) {
                this.notify(this.$t('conta.preenchaTodos'), 'warning');
                return;
            }

            this.loading = true;

            const payload = {
                token: this.token,
                password: this.password,
                nome: this.nome,
                whatsapp: this.value,
                whatsapp_ddi: this.ddi,
            };

            this.$http.post('validate-account', payload)
                .then(resp => {
                    const data = resp.data;

                    if (data.type === 'warning') {
                        this.notify(data.msg, 'warning');
                        return;
                    }

                    this.$emit('create', data.data);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped>
</style>
